import { getCurrentObjectTypeId } from '../../init/selectors/routerStateSelectors';
import { createFrozenSelector } from '../../utils/createFrozenSelector';
export const getPinnedViewsSlice = state => state.pinnedViews;
const emptyArray = [];
export const getPinnedViewIds = createFrozenSelector([getPinnedViewsSlice, getCurrentObjectTypeId], (data, typeId) => {
  return data.values[typeId] || emptyArray;
});
export const getPinnedViewIdsOptimisticUpdates = createFrozenSelector([getPinnedViewsSlice, getCurrentObjectTypeId], (data, typeId) => {
  return data.optimisticUpdates[typeId];
});